'use client';
import CountUp from "react-countup";
 
import Slider, { SliderItem } from "@/element/common/Slider";
import ShowGoToTop, { goToTop } from "./scrolltotop";
import { motion } from "framer-motion";
import Link from "next/link";
import VideoModal from "./videoModal";  
import { CircularProgressBar } from "react-percentage-bar";
// import "react-percentage-bar/dist/index.css";
import ImageModal from "./imageModal";
import EnquirySupportTicket from "./EnquirySupportTicket";
 import {
    Accordion, 
    AccordionItem, 
    AccordionBody, 
    AccordionHeader, 
    AccordionButton,
    AccordionCollapse,
    useAccordionButton,
    Alert,
    AlertHeading,
    AlertLink,
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    ButtonGroup,
    ButtonToolbar,
    Button,
    ToggleButtonGroup,
    ToggleButton,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardImg,
    CardImgOverlay,
    CardLink,
    CardSubtitle,
    CardText,
    CardTitle,
    CardGroup,
    Carousel,
    CarouselItem,
    CarouselCaption,
    CloseButton,
    DropdownButton,
    SplitButton,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    DropdownHeader,
    DropdownDivider,
    Figure,
    FigureImage,
    FigureCaption,
    Image,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalDialog,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Navbar,
    NavbarBrand,
    NavbarToggle,
    NavbarCollapse,
    Nav,
    NavItem,
    NavLink,
    NavDropdown,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasTitle,
    OffcanvasBody,
    Overlay,
    OverlayTrigger,
    Tooltip,
    Popover,
    PopoverBody,
    PopoverHeader,
    Pagination,
    PageItem,
    Placeholder,
    PlaceholderButton,
    ProgressBar,
    Spinner,
    Table,
    Tabs,
    Tab,
    TabContainer,
    TabContent,
    TabPane,
    Toast,
    ToastHeader,
    ToastBody,
    ToastContainer, 
} from "react-bootstrap";
const MotionDiv = motion.div;
const MotionSpan = motion.span;
const MotionA = motion.a;
const MotionH1 = motion.h1;
const MotionH2 = motion.h2;
const MotionH3 = motion.h3;
const MotionH4 = motion.h4;
const MotionH5 = motion.h5;
const MotionH6 = motion.h6;
const MotionP = motion.p;
const MotionUl = motion.ul;
const MotionLi = motion.li;
const MotionLink = motion(Link); 

export {
    CountUp,
    CircularProgressBar,
    
    MotionDiv,
    MotionSpan,
    MotionA,
    MotionH1,
    MotionH2,
    MotionH3,
    MotionH4,
    MotionH5,
    MotionH6,
    MotionP,
    MotionUl,
    MotionLi,
    MotionLink,
 
    Accordion, 
    AccordionItem, 
    AccordionBody, 
    AccordionHeader, 
    AccordionButton,
    AccordionCollapse,
    useAccordionButton,
    Alert,
    AlertHeading,
    AlertLink,
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    ButtonGroup,
    ButtonToolbar,
    Button,
    ToggleButtonGroup,
    ToggleButton,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardImg,
    CardImgOverlay,
    CardLink,
    CardSubtitle,
    CardText,
    CardTitle,
    CardGroup,
    Carousel,
    CarouselItem,
    CarouselCaption,
    CloseButton,
    DropdownButton,
    SplitButton,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    DropdownHeader,
    DropdownDivider,
    Figure,
    FigureImage,
    FigureCaption,
    Image,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalDialog,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Navbar,
    NavbarBrand,
    NavbarToggle,
    NavbarCollapse,
    Nav,
    NavItem,
    NavLink,
    NavDropdown,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasTitle,
    OffcanvasBody,
    Overlay,
    OverlayTrigger,
    Tooltip,
    Popover,
    PopoverBody,
    PopoverHeader,
    Pagination,
    PageItem,
    Placeholder,
    PlaceholderButton,
    ProgressBar,
    Spinner,
    Table,
    Tabs,
    Tab,
    TabContainer,
    TabContent,
    TabPane,
    Toast,
    ToastHeader,
    ToastBody,
    ToastContainer,  
    
    Slider,
    SliderItem,
    VideoModal,
    ImageModal,
    EnquirySupportTicket,
    ShowGoToTop,
    goToTop,
};


